<template>
  <div>
    <el-cascader
        class="select-area-content"
        ref="cascader"
      :options="options"
      v-model="value1"
      @change="handleChange"
      filterable
      :props="{value:'label'}"
      placeholder="省/市/区"
    ></el-cascader>
  </div>
</template>

<script>
// 引入省市区数据包
import { regionData } from '@/common/js/areaJson.js'
// console.log(regionData)
// console.log(codeToText)
export default {
  name: "VcSelectArea",
  props: ['value'],
  data() {
    return {
      options: regionData,
      selectedOptions: []
    }
  },
  computed: {
    value1: {
      set(val) {
        this.$emit("input", val)
      },
      get() {
        return this.value
      }
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
      this.getCheckedNodes()
    },
    getCheckedNodes() {
      let nodes = this.$refs.cascader.getCheckedNodes()
      console.log(nodes)
    }
  }
}

</script>
<style scoped>
.select-area-content {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .select-area-content input {
  width: 100%;
  height: 60px;
  border: 0;
}
</style>
